import InfiniteScroll from 'infinite-scroll';

/**
 *
 * @param el {HTMLElement}
 * @param list {string}
 * @param next {string}
 * @param button {string}
 * @param append {string}
 * @returns {InfiniteScroll|false}
 */
export default function loadNext(el, {
	list = '[data-ajax-news="list"]',
	next = '[data-ajax-news="next"]',
	button = '[data-ajax-news="trigger"]',
	append = '[data-ajax-news="item"]',
}) {
	if (!el) return false;
	
	const buttonEl = el.querySelector(button);
	if (!buttonEl) return false;
	
	const scroll = new InfiniteScroll(list, {
		// options
		path            : next,
		append,
		history         : false,
		button          : buttonEl,
		scrollThreshold : false,
		debug           : false,
	});
	scroll.on('request', () => {
		buttonEl.classList.add('b-btn--loading');
	});
	scroll.on('append', () => {
		buttonEl.classList.remove('b-btn--loading');
	});
	scroll.on('last', () => {
		buttonEl.remove();
	});
	
	return scroll;
}
